// extracted by mini-css-extract-plugin
module.exports = {"VolumeDeCompras":"VolumeDeCompras_VolumeDeCompras__1Ti7J"};